import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 1.5rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1.5rem;
	overflow: auto;
`;

export const backBtn = styled.button`
	all: unset;
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;

	> svg {
		font-size: 3rem;
		color: ${color.system.info};
	}

	> p {
		color: ${color.system.info};
		font-size: 1.3rem;
	}
`;

export const containerItens = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> p {
		font-size: 1.5rem;
		color: ${color.interface.darkgray};
	}
`;

export const btns = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
`;

export const listItens = styled.div`
	width: 99.5%;
	display: flex;

	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	gap: 1rem;
`;

export const item = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	border-radius: 5px;
	padding: 1rem;

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

export const infos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	> p {
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
		> b {
			font-size: 1.3rem;
			font-family: nunito-bold;
			color: ${color.interface.darkgray};
		}
	}
`;

export const imgs = styled.div`
	width: 100%;
	box-sizing: border-box;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	> img {
		width: 100%;
		max-height: 100%;
		min-height: 100%;
		height: 100%;

		border-radius: 5px;
		object-fit: fill;
	}
`;

export const btnsItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 25px;
		color: ${color.interface.darkgray};
	}
`;
